import {
  ReactElement,
  useState,
  FormEvent,
  useContext,
  ChangeEventHandler,
} from "react";
import { useNavigate } from "react-router-dom";

import { PATH_TO_HOME } from "constants/navigation";
import { SUCCESSFUL_EMAIL_CHANGE } from "constants/pageAlertsCopy";

import PageAlertContext from "contexts/PageAlertContext";

import useGetProfileData from "hooks/useGetProfileData";
import useUpdateProfileData from "hooks/useUpdateProfileData";

import PageCard from "global-components/pageCard/PageCard";
import EditProfileEmailForm from "./components/editProfileEmailForm/EditProfileEmailForm";

const EditProfile = (): ReactElement => {
  const [emailInput, setEmailInput] = useState<string>("");
  const [inlineError, setInlineError] = useState<string>("");
  const clearInlineError = () => setInlineError("");
  const { data: profileData } = useGetProfileData();
  const { email: savedEmail = "" } = profileData;
  const { mutate: saveProfileData, isLoading } = useUpdateProfileData();
  const { setAlert } = useContext(PageAlertContext);
  const navigate = useNavigate();

  const handleChangeInput: ChangeEventHandler<HTMLInputElement> = (e) => {
    clearInlineError();
    setEmailInput(e.target.value);
  };

  const handleSuccess = () => {
    setAlert({
      message: SUCCESSFUL_EMAIL_CHANGE,
      color: "additive",
    });
    navigate(PATH_TO_HOME);
  };

  const handleSubmitForm = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    saveProfileData(
      {
        email: emailInput,
      },
      {
        onSuccess: () => {
          handleSuccess();
        },
        onError: (error) => {
          setInlineError(error?.errorCauses[0]?.errorSummary ?? "");
        },
      },
    );
  };

  return (
    <PageCard
      showBackToHomeLink={true}
      title="Personal Email"
      description="This is the email address we'll use to contact you when using any
        Justworks product. It should be an email address that's not
        managed by your employer."
    >
      <EditProfileEmailForm
        emailInput={emailInput}
        savedEmail={savedEmail}
        inlineError={inlineError}
        isLoading={isLoading}
        onSubmit={handleSubmitForm}
        onChange={handleChangeInput}
      />
    </PageCard>
  );
};

export default EditProfile;
